<template>
  <div>
    <div class="avert-toolbar">
      <label class="avert-toggle">
        <input type="checkbox" v-model="hideOk"> Masquer les avertissements sans problème
      </label>
      <button class="btn btn-default btn-xs" @click.prevent="refreshAll">
        <i class="fa fa-refresh"></i> Tout rafraîchir
      </button>
    </div>

    <div class="box box-primary" v-for="group in groups" :key="group.key" v-if="!(hideOk && groupCount(group) === 0)">
      <div class="box-header with-border avert-group-header" @click="toggleGroup(group.key)">
        <i class="fa avert-group-chevron" :class="groupExpanded[group.key] ? 'fa-chevron-down' : 'fa-chevron-right'"></i>
        <i class="fa" :class="'fa-' + group.icon"></i>
        <h3 class="box-title">{{ group.title }}</h3>
        <span class="label pull-right" :class="groupCount(group) > 0 ? 'label-warning' : 'label-success'">
          {{ groupCount(group) }}
        </span>
      </div>
      <div class="box-body no-padding" v-show="groupExpanded[group.key]">
        <ul class="avert-list">
          <template v-for="url in group.urls">
            <li class="avert-row" :key="url" v-if="!(hideOk && count(url) === 0)">
              <div class="avert-row-head" @click="toggle(url)">
                <i class="fa avert-status"
                   :class="urls[url].loading ? 'fa-spinner fa-spin text-muted' : (count(url) > 0 ? 'fa-exclamation-triangle text-yellow' : 'fa-check-circle text-green')"></i>
                <span class="avert-label">{{ urls[url].label }}</span>
                <span class="label avert-count" :class="count(url) > 0 ? 'label-warning' : 'label-default'">
                  {{ urls[url].loading ? '…' : count(url) }}
                </span>
                <i class="fa avert-chevron" v-if="count(url) > 0"
                   :class="expanded[url] ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
              </div>

              <div class="avert-detail" v-show="expanded[url] && count(url) > 0">

                <!-- Type A : statut / population -->
                <table class="table table-hover table-responsive" v-if="tableType(url) === 'A'">
                  <thead>
                  <tr>
                    <th>Numéro club</th>
                    <th>Club</th>
                    <th>Nombre de membres</th>
                    <th>Statut</th>
                    <th>Erreur détectée</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="result in urls[url].result" :key="result.id">
                    <td>
                      <router-link :to="{ name: 'Club', params: { club_id: result.id }}">{{ result.numero_club }}</router-link>
                    </td>
                    <td>
                      <router-link :to="{ name: 'Club', params: { club_id: result.id }}">{{ result.club.toUpperCase() }}</router-link>
                    </td>
                    <td>{{ result.licences_membres_actives_at_date.length }} membre{{ $pluralize(result.licences_membres_actives_at_date.length) }}</td>
                    <td><span :class="{'text-green': result.isLicencie != null, 'text-red': result.isLicencie == null}">{{ result.isLicencie != null ? "Licencie" : "Non-licencié" }}</span></td>
                    <td>{{ urls[url].error }}</td>
                  </tr>
                  </tbody>
                </table>

                <!-- Type B : composition du comité -->
                <table class="table table-hover table-responsive" v-else-if="tableType(url) === 'B'">
                  <thead>
                  <tr>
                    <th>Numéro club</th>
                    <th>Club</th>
                    <th>Nombre de membres</th>
                    <th>Cotisation reçue</th>
                    <th>Payement cotisation</th>
                    <th>Erreur détectée</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="result in urls[url].result" :key="result.id">
                    <td>
                      <router-link :to="{ name: 'Club', params: { club_id: result.id }}">{{ result.numero_club }}</router-link>
                    </td>
                    <td>
                      <router-link :to="{ name: 'Club', params: { club_id: result.id }}">{{ result.club.toUpperCase() }}</router-link>
                    </td>
                    <td>{{ result.licences_membres_actives_at_date.length }} membre{{ $pluralize(result.licences_membres_actives_at_date.length) }}</td>
                    <td><span :class="{'text-green': result.licence_active.inscription != null, 'text-red': result.licence_active.inscription == null}">{{ result.licence_active.inscription != null ? "Reçu" : "Non-reçu" }}</span></td>
                    <td><span :class="{'text-green': result.licence_active.payement != null, 'text-red': result.licence_active.payement == null}">{{ result.licence_active.payement != null ? "Reçu" : "Non-reçu" }}</span></td>
                    <td>{{ urls[url].error }}</td>
                  </tr>
                  </tbody>
                </table>

                <!-- Type C-moniteur : alertes liées au moniteur -->
                <table class="table table-hover table-responsive" v-else-if="tableType(url) === 'Cmon'">
                  <thead>
                  <tr>
                    <th>Numéro club</th>
                    <th>Club</th>
                    <th>Nombre de membres</th>
                    <th>Moniteur</th>
                    <th>Erreur détectée</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="result in urls[url].result" :key="result.id">
                    <td>
                      <router-link :to="{ name: 'Club', params: { club_id: result.id }}">{{ result.numero_club }}</router-link>
                    </td>
                    <td>
                      <router-link :to="{ name: 'Club', params: { club_id: result.id }}">{{ result.club.toUpperCase() }}</router-link>
                    </td>
                    <td>{{ result.licences_membres_actives_at_date.length }} membre{{ $pluralize(result.licences_membres_actives_at_date.length) }}</td>
                    <td>
                      <router-link v-if="getMoniteur(result)" :to="{ name: 'Member', params: { member_id: getMoniteur(result).id_membre }}">
                        {{ getMoniteur(result).membre.fullName }}
                      </router-link>
                      <span v-else class="text-red">PAS DE MONITEUR</span>
                    </td>
                    <td>{{ urls[url].error }}</td>
                  </tr>
                  </tbody>
                </table>

                <!-- Type C-fonction : mandataire non affilié à la fédération -->
                <table class="table table-hover table-responsive" v-else-if="tableType(url) === 'Cfonc'">
                  <thead>
                  <tr>
                    <th>Numéro club</th>
                    <th>Club</th>
                    <th>Nombre de membres</th>
                    <th>{{ fonctionLabel(url) }}</th>
                    <th>Erreur détectée</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="result in urls[url].result" :key="result.id">
                    <td>
                      <router-link :to="{ name: 'Club', params: { club_id: result.id }}">{{ result.numero_club }}</router-link>
                    </td>
                    <td>
                      <router-link :to="{ name: 'Club', params: { club_id: result.id }}">{{ result.club.toUpperCase() }}</router-link>
                    </td>
                    <td>{{ result.licences_membres_actives_at_date.length }} membre{{ $pluralize(result.licences_membres_actives_at_date.length) }}</td>
                    <td>
                      <template v-if="getFonctionMembres(result, url).length">
                        <div v-for="m in getFonctionMembres(result, url)" :key="m.id_membre">
                          <router-link :to="{ name: 'Member', params: { member_id: m.id_membre }}">
                            {{ m.membre ? m.membre.fullName : '—' }}
                          </router-link>
                          <span v-if="m.membre && !m.membre.isLicencie" class="text-red"> — non affilié</span>
                        </div>
                      </template>
                      <span v-else class="text-red">Aucun {{ fonctionLabel(url).toLowerCase() }}</span>
                    </td>
                    <td>{{ urls[url].error }}</td>
                  </tr>
                  </tbody>
                </table>

              </div>
            </li>
          </template>
        </ul>
      </div>
    </div>
  </div>
</template>


<script>
import {mapGetters, mapActions} from 'vuex'

var _ = require('underscore')

var moment = require('moment')

export default {
  data() {
    var year = moment().year()
    var urls = {
      // Affiliation des mandataires (licence active obligatoire)
      clubPresidentNotLicencied: {loading: false, url: "clubPresidentNotLicencied", param: null, label: "Président non affilié", error: "Président non affilié à la fédération", result: []},
      clubSecretaireNotLicencied: {loading: false, url: "clubSecretaireNotLicencied", param: null, label: "Secrétaire non affilié", error: "Secrétaire non affilié à la fédération", result: []},
      clubTresorierNotLicencied: {loading: false, url: "clubTresorierNotLicencied", param: null, label: "Trésorier non affilié", error: "Trésorier non affilié à la fédération", result: []},
      clubCorrespondantNotLicencied: {loading: false, url: "clubCorrespondantNotLicencied", param: null, label: "Correspondant non affilié", error: "Correspondant non affilié à la fédération", result: []},
      clubMoniteurNotLicencied: {loading: false, url: "clubMoniteurNotLicencied", param: null, label: "Moniteur non affilié", error: "Moniteur non affilié à la fédération", result: []},
      clubMoniteurAdjointNotLicencied: {loading: false, url: "clubMoniteurAdjointNotLicencied", param: null, label: "Moniteur adjoint non affilié", error: "Moniteur adjoint non affilié à la fédération", result: []},
      clubMembreSportifNotLicencied: {loading: false, url: "clubMembreSportifNotLicencied", param: null, label: "Membre sportif non affilié", error: "Membre sportif non affilié à la fédération", result: []},
      clubReferentEthiqueNotLicencied: {loading: false, url: "clubReferentEthiqueNotLicencied", param: null, label: "Référent éthique non affilié", error: "Référent éthique non affilié à la fédération", result: []},

      // Cotisation & licences
      clubWithLicenceIncomplete: {loading: false, url: "clubWithLicenceIncomplete", param: year, label: "Cotisation annuelle non payée", error: "Pas de licence active", result: []},
      clubAffilieAnneePasseePasMaintenant: {loading: false, url: "clubAffilieAnneePasseePasMaintenant", param: null, label: "Affilié en " + (year - 1) + " mais pas en " + year, error: "Club non-affilié cette année", result: []},

      // Composition du comité
      clubWithoutCorrespondant: {loading: false, url: "clubWithoutCorrespondant", param: null, label: "Sans correspondant", error: "Pas de correspondant", result: []},
      clubWithoutReferentEthique: {loading: false, url: "clubWithoutReferentEthique", param: null, label: "Sans référent éthique", error: "Pas de référent éthique", result: []},
      clubLicencieNotOnWebsite: {loading: false, url: "clubLicencieNotOnWebsite", param: null, label: "Licencié non affiché sur le site", error: "Non-affiché sur le site", result: []},

      // Qualifications du moniteur
      clubMoniteurNotAdeps: {loading: false, url: "clubMoniteurNotAdeps", param: null, label: "Moniteur non formé ADEPS", error: "Moniteur non-formé ADEPS (ou pas de données)", result: []},
      clubMoniteurNotDan: {loading: false, url: "clubMoniteurNotDan", param: null, label: "Moniteur pas ceinture noire", error: "Moniteur pas ceinture noire (ou pas de données)", result: []},
      clubMoniteurAdjointNotMSI: {loading: false, url: "clubMoniteurAdjointNotMSI", param: null, label: "Moniteur adjoint non MSI", error: "Moniteur adjoint non-diplômé Moniteur Sportif Initiateur (ou pas de données)", result: []},

      // Population du club
      clubWithLicenceButNoMembers: {loading: false, url: "clubWithLicenceButNoMembers", param: year, label: "Licencié sans membres", error: "Pas de membres", result: []},
      clubWithBetweenZeroAndTen: {loading: false, url: "clubWithBetweenZeroAndTen", param: year, label: "Entre 0 et 10 membres", error: "Faible population", result: []},
    }

    var groups = [
      {key: "affiliation", title: "Affiliation des mandataires", icon: "id-badge", urls: ["clubPresidentNotLicencied", "clubSecretaireNotLicencied", "clubTresorierNotLicencied", "clubCorrespondantNotLicencied", "clubMoniteurNotLicencied", "clubMoniteurAdjointNotLicencied", "clubMembreSportifNotLicencied", "clubReferentEthiqueNotLicencied"]},
      {key: "cotisation", title: "Cotisation & licences", icon: "money", urls: ["clubWithLicenceIncomplete", "clubAffilieAnneePasseePasMaintenant"]},
      {key: "comite", title: "Composition du comité", icon: "users", urls: ["clubWithoutCorrespondant", "clubWithoutReferentEthique", "clubLicencieNotOnWebsite"]},
      {key: "qualif", title: "Qualifications du moniteur", icon: "graduation-cap", urls: ["clubMoniteurNotAdeps", "clubMoniteurNotDan", "clubMoniteurAdjointNotMSI"]},
      {key: "population", title: "Population du club", icon: "bar-chart", urls: ["clubWithLicenceButNoMembers", "clubWithBetweenZeroAndTen"]},
    ]

    var expanded = {}
    Object.keys(urls).forEach(function (k) { expanded[k] = false })
    var groupExpanded = {}
    groups.forEach(function (g) { groupExpanded[g.key] = true })

    return {
      hideOk: false,
      urls: urls,
      groups: groups,
      expanded: expanded,
      groupExpanded: groupExpanded,
      // url de l'avertissement -> poste_meta de la fonction concernée
      fonctionByUrl: {
        clubPresidentNotLicencied: "president",
        clubSecretaireNotLicencied: "secretaire",
        clubTresorierNotLicencied: "tresorier",
        clubCorrespondantNotLicencied: "correspondant",
        clubMoniteurNotLicencied: "moniteur",
        clubMoniteurAdjointNotLicencied: "moniteur_adjoint",
        clubMembreSportifNotLicencied: "membre_sportif",
        clubReferentEthiqueNotLicencied: "referent_ethique",
      },
    }
  },
  props: {},
  computed: {
    ...mapGetters({
      getRoute: 'getRoute',
      getPostes: 'getPostes',
    }),
  },
  mounted: function () {
    if (!this.getPostes)
      this.loadPostes()
    _.each(this.urls, item => {
      this.getAvertissement(item)
    })
  },
  methods: {
    ...mapActions({
      setRecap: 'setRecap',
      setPostes: 'setPostes',
    }),
    count: function (url) {
      return this.urls[url].result ? this.urls[url].result.length : 0
    },
    groupCount: function (group) {
      let self = this
      return group.urls.reduce((total, url) => total + self.count(url), 0)
    },
    toggle: function (url) {
      if (this.count(url) === 0)
        return
      this.expanded[url] = !this.expanded[url]
    },
    toggleGroup: function (key) {
      this.groupExpanded[key] = !this.groupExpanded[key]
    },
    tableType: function (url) {
      if (this.fonctionByUrl[url])
        return 'Cfonc'
      if (['clubMoniteurNotAdeps', 'clubMoniteurNotDan', 'clubMoniteurAdjointNotMSI', 'clubAffilieAnneePasseePasMaintenant'].includes(url))
        return 'Cmon'
      if (['clubWithoutCorrespondant', 'clubWithoutReferentEthique', 'clubLicencieNotOnWebsite'].includes(url))
        return 'B'
      return 'A'
    },
    posteByMeta: function (meta) {
      return _.findWhere(this.getPostes || [], {poste_meta: meta})
    },
    fonctionLabel: function (url) {
      let poste = this.posteByMeta(this.fonctionByUrl[url])
      return poste ? poste.poste : 'Mandataire'
    },
    getFonctionMembres: function (club, url) {
      let poste = this.posteByMeta(this.fonctionByUrl[url])
      if (!poste)
        return []
      return _.where(club.comite || [], {id_poste: poste.id})
    },
    getMoniteur: function (club) {
      return _.first(_.where(club.comite, {id_poste: 3}))
    },
    loadPostes: function () {
      this.$http.get(this.getRoute('getPostesForClub')).then((response) => {
        this.setPostes(response.body)
      }, (response) => {
      })
    },
    getAvertissement: function (item) {
      this.urls[item.url].loading = true
      this.$http.get(this.getRoute('Avertissement.' + item.url) + (item.param != null ? item.param : "")).then((response) => {
        // Les avertissements basés sur ->filter() côté Laravel préservent les clés
        // et sont sérialisés en objet ({"2":{...}}) plutôt qu'en tableau : on normalise.
        this.urls[item.url].result = _.values(response.body)
        this.urls[item.url].loading = false
      }, (response) => {
        this.urls[item.url].loading = false
      })
    },
    refreshAll: function () {
      _.each(this.urls, item => {
        this.getAvertissement(item)
      })
    },
  },
  beforeRouteUpdate(to, from, next) {
  },
  beforeRouteEnter(to, from, next) {
  },
  watch: {},
  components: {}
}
</script>

<style scoped>
.avert-toolbar {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
}

.avert-toggle {
  font-weight: normal;
  margin: 0 18px 0 0;
  cursor: pointer;
}

.avert-toggle input {
  margin-right: 6px;
}

.avert-group-header {
  cursor: pointer;
  user-select: none;
}

.avert-group-header .box-title {
  display: inline-block;
  margin-left: 8px;
}

.avert-group-chevron {
  width: 14px;
  color: #999;
}

.avert-list {
  list-style: none;
  margin: 0;
  padding: 0;
}

.avert-row {
  border-top: 1px solid #f4f4f4;
}

.avert-row:first-child {
  border-top: 0;
}

.avert-row-head {
  display: flex;
  align-items: center;
  padding: 9px 14px;
  cursor: pointer;
}

.avert-row-head:hover {
  background: #f9fafc;
}

.avert-status {
  width: 18px;
  text-align: center;
  margin-right: 10px;
}

.avert-label {
  flex: 1;
}

.avert-count {
  margin-left: 8px;
  min-width: 22px;
}

.avert-chevron {
  margin-left: 12px;
  color: #aaa;
}

.avert-detail {
  padding: 0 14px 12px 42px;
}

.avert-detail .table {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Secretariat/Avertissement/Avertissement_club.vue